document.addEventListener('DOMContentLoaded', () => {
  function updateProductImages(button) {
    const productCard = button.closest('.product-card-wrapper');

    if (!productCard) return;

    const firstImage = productCard.querySelector('.card__media img:first-child');
    const secondImage = productCard.querySelector('.card__media img:nth-child(2)');

    const firstImageUrl = button.dataset.firstimage;
    const secondImageUrl = button.dataset.secondimage;

    if (firstImage && firstImageUrl) {
      firstImage.src = firstImageUrl;
      firstImage.removeAttribute('srcset');
    }

    if (secondImage && secondImageUrl) {
      secondImage.src = secondImageUrl;
      secondImage.removeAttribute('srcset');
    }
  }
  document.querySelectorAll('.product-card-wrapper').forEach((productCard) => {
    const activeButton = productCard.querySelector('.card-color-variant button.active');

    if (activeButton) {
      updateProductImages(activeButton);
    }
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.card-color-variant button');

    if (!button) return;

    const colorVariant = button.closest('.card-color-variant');
    colorVariant.querySelectorAll('button').forEach((btn) => {
      btn.classList.remove('active');
    });
    button.classList.add('active');
    updateProductImages(button);
  });
});